import React, { useState } from 'react';
import { Edit } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import { FormSpy } from 'react-final-form';

import NavigationPrompt from '../../core/components/NavigationPrompt';
import EditToolbar from '../../core/components/edit/EditToolbar';
import FormTitleBar from '../../core/components/FormTitleBar';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import { removePathEnd, getInitials } from '../../core/utils';
import DocumentTypeSummary from './DocumentTypeSummary';
import CustomSimpleForm from '../../core/components/form/CustomSimpleForm';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const DocumentTypeTitle = ({ record }) => {
  return (
    <FormTitleBar
      name={record.description}
      showAvatar
      avatarContent={getInitials(record.description)}
    />
  );
};

const DocumentTypeEdit = props => {
  const [whenBlockNavigation, setWhenBlockNavigation] = useState(false);

  const {
    classes,
    hasCreatePermission,
    hasEditPermission,
    hasDeletePermission,
    userProfile,
    ...rest
  } = props;
  return (
    <React.Fragment>
      <NavigationPrompt
        when={whenBlockNavigation}
        adjustMatchingPath={removePathEnd}
        hasEditPermission={hasEditPermission}
      >
        {(isOpen, onConfirm, onCancel) => (
          <LeaveConfirm
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onCancel}
          />
        )}
      </NavigationPrompt>
      <Edit
        {...rest}
        record={{
          description: ''
        }}
        undoable={false}
        title={<DocumentTypeTitle />}
        classes={{
          noActions: classes.noActions
        }}
      >
        <CustomSimpleForm
          toolbar={
            <EditToolbar
              {...rest}
              hasEditPermission={hasEditPermission}
              hasDeletePermission={hasDeletePermission}
              onBeforeDelete={() => setWhenBlockNavigation(false)}
            />
          }
          variant="standard"
          margin="normal"
        >
          <DocumentTypeSummary />
          <FormSpy
            subscription={{
              dirty: true
            }}
            onChange={props => setWhenBlockNavigation(props.dirty)}
          />
        </CustomSimpleForm>
      </Edit>
    </React.Fragment>
  );
};

export default withStyles(styles)(DocumentTypeEdit);
